module.exports = __webpack_public_path__ + "static/img/title.f0c086f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/k_mueller/title.jpg
// module id = 415
// module chunks = 1